export default "__VITE_ASSET__$L1ZpxH7__"